import Vue from 'vue'
import { ToastPlugin, ModalPlugin, VBTogglePlugin } from 'bootstrap-vue'
import vClickOutside from 'v-click-outside'
// import VueCompositionAPI from '@vue/composition-api'
import router from './router'
import store from './store'
import App from './App.vue'
import config from './config';
// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/vue-select'
// import Mouseflow from '@/libs/mouseflow.js';

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VBTogglePlugin)

// custom directive
Vue.use(vClickOutside)

// Composition API
// Vue.use(VueCompositionAPI)

require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false
if (config.lockOrientation) {
  if (window.screen.orientation && window.screen.orientation.lock) {
    window.screen.orientation.lock("portrait")
  } else if (window.screen.lockOrientation) {
    window.screen.lockOrientation("portrait")
  }
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')